<design-slide-up-card
  #card
  [isCardOpen]="!!isCardOpen"
  class="route-planning-results"
  [showLogoInHeader]="true"
  [showBackgroundImage]="true"
  [title]="routePlanningText"
  [hideHeaderInDesktop]="true"
  [class]="direction"
  >
  <app-results-header (onBackClick)="handleClose()">
    <ng-container buttons>
      <mot-button
        type="button"
        icon="bars-filter"
          [buttonClass]="
            '!text-white !bg-transparent' +
            (!!appliedFilters ? ' filters-active' : '')
          "
        (onClick)="openFiltersMenu()"
        [text]="filterText"
        iconClass="text-2xl"
        ariaHaspopup="dialog"
        />

        <mot-button
          type="button"
          icon="share-nodes"
          buttonClass="!text-white !bg-transparent"
          iconClass="text-2xl"
          [text]="shareRouteText"
          (onClick)="shareResults()"
          ariaHaspopup="dialog"
          />
          <mot-menu
              [menuVert]="false"
              [menuItems]="moreActionsMenuItems"
              [menuButtonAriaLabel]="moreActionsMenuText"
              [dir]="direction"
              buttonClass="!rounded-xl !text-white !bg-transparent !w-8 !h-8 !min-w-0"
              buttonActiveClass="!rounded-xl !bg-white !w-8 !h-8 !min-w-0 !text-[#0C3058]"
              />
            </ng-container>
            <app-addresses-details
              content
              [origin]="formValues.origin.addressDetails?.label"
              [destination]="formValues.destination.addressDetails?.label"
              [stop]="formValues.stop?.addressDetails?.label"
              [leg]="leg?.addressDetails?.label"
              [asRouteSummaryHeading]="true"
              />
            </app-results-header>

            <div class="w-full rounded-t-xl bg-white h-full pb-4 overflow-y-auto flex-1" id="printableArea">
              @if (isLoadingData) {
                <app-loader/>
              }
              @if (isMobile) {
                <mat-tab-group
                  [dir]="direction"
                  mat-stretch-tabs="false"
                  [disableRipple]="true"
                  class="h-full use-padding"
                  >
                  <mat-tab>
                    <ng-template mat-tab-label>{{ availableRoutesText }}</ng-template>
                    <app-source-destination-results-list
                      [results]="results"
                      [resubmittedWithoutFilters]="resubmittedWithoutFilters"
                      (onResultClick)="handleResultClick($event)"
                      (onResultHover)="handleResultHover($event)"
                      [isMobile]="isMobile"
                      [isLoading]="isLoading"
                      />
                  </mat-tab>
                  @if (!!results?.length) {
                    <mat-tab>
                      <ng-template mat-tab-label>{{ showOnMapText }}</ng-template>
                      <ng-template matTabContent>
                        <app-source-destination-results-map />
                      </ng-template>
                    </mat-tab>
                  }
                </mat-tab-group>
              } @else {
                <app-source-destination-results-list
                  class="use-padding"
                  [results]="results"
                  [resubmittedWithoutFilters]="resubmittedWithoutFilters"
                  (onResultClick)="handleResultClick($event)"
                  (onResultHover)="handleResultHover($event)"
                  [isMobile]="isMobile"
                  [isLoading]="isLoading"
                  />
              }
              </div>
            </design-slide-up-card>
